import { useState, useEffect } from 'react';

function ResetPassword() {
  const [token, setToken] = useState('');
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const t = params.get('token');
    if (!t) {
      setError('Invalid reset link. Please request a new one.');
    } else {
      setToken(t);
    }
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (password.length < 8) {
      setError('Password must be at least 8 characters');
      return;
    }
    if (password !== confirm) {
      setError('Passwords do not match');
      return;
    }

    setLoading(true);
    try {
      const res = await fetch((process.env.REACT_APP_API_URL || '') + '/api/auth/reset-password', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token, password })
      });
      const data = await res.json();
      if (!res.ok) {
        setError(data.error || 'Failed to reset password');
        return;
      }
      setSuccess(true);
    } catch (err) {
      setError('Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  if (success) {
    return (
      <div style={styles.container}>
        <div style={styles.card}>
          <h1 style={styles.title}>Password reset</h1>
          <p style={styles.body}>Your password has been updated successfully.</p>
          <a href="/" style={styles.button}>Sign in now</a>
        </div>
      </div>
    );
  }

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <h1 style={styles.title}>Set new password</h1>
        <p style={styles.subtitle}>Choose a new password for your account.</p>
        {error && <p style={styles.error}>{error}</p>}
        <form onSubmit={handleSubmit}>
          <input
            style={styles.input}
            type="password"
            placeholder="New password (min 8 characters)"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
          <input
            style={styles.input}
            type="password"
            placeholder="Confirm new password"
            value={confirm}
            onChange={(e) => setConfirm(e.target.value)}
            required
          />
          <button style={loading ? styles.buttonDisabled : styles.buttonSubmit} type="submit" disabled={loading || !token}>
            {loading ? 'Resetting...' : 'Reset Password'}
          </button>
        </form>
        <a href="/" style={styles.backLink}>Back to sign in</a>
      </div>
    </div>
  );
}

const styles = {
  container: { minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: '#f5f5f5' },
  card: { backgroundColor: '#fff', padding: '40px', borderRadius: '8px', width: '100%', maxWidth: '400px', boxShadow: '0 2px 12px rgba(0,0,0,0.08)' },
  title: { fontSize: '24px', fontWeight: '700', color: '#1a1a1a', marginBottom: '8px' },
  subtitle: { fontSize: '14px', color: '#666', marginBottom: '24px' },
  body: { fontSize: '14px', color: '#444', marginBottom: '20px', lineHeight: 1.6 },
  error: { backgroundColor: '#fdecea', color: '#c0392b', padding: '10px', borderRadius: '4px', marginBottom: '16px', fontSize: '14px' },
  input: { width: '100%', padding: '12px', marginBottom: '16px', borderRadius: '4px', border: '1px solid #ddd', fontSize: '14px', display: 'block', boxSizing: 'border-box' },
  buttonSubmit: { width: '100%', padding: '12px', backgroundColor: '#c0392b', color: '#fff', border: 'none', borderRadius: '4px', fontSize: '16px', fontWeight: '600', cursor: 'pointer' },
  buttonDisabled: { width: '100%', padding: '12px', backgroundColor: '#999', color: '#fff', border: 'none', borderRadius: '4px', fontSize: '16px', fontWeight: '600' },
  button: { display: 'block', width: '100%', padding: '12px', backgroundColor: '#c0392b', color: '#fff', border: 'none', borderRadius: '4px', fontSize: '16px', fontWeight: '600', cursor: 'pointer', textAlign: 'center', textDecoration: 'none', boxSizing: 'border-box' },
  backLink: { display: 'block', marginTop: '16px', textAlign: 'center', fontSize: '14px', color: '#666' },
};

export default ResetPassword;
